import { ReactElement, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { CatalogTab } from '../../../store/uiState/UiStateStore'
import { StoreInstances } from '../../../store/StoreInstancesContainer'
import { SimpleModal } from '../../../ui-components/modals/SimpleModal'
import { observer } from 'mobx-react-lite'

interface VehicleRequiredModalProps {
  isMobile?: boolean
}

const VehicleRequiredModal = observer(
  (props: VehicleRequiredModalProps): ReactElement => {
    const { isMobile } = props
    const [showVehicleRequired, setShowVehicleRequired] = useState(true)
    const navigate = useNavigate()
    const { uiStore } = StoreInstances

    const handleVehicleRequired = (): void => {
      setShowVehicleRequired(false)
      navigate('/home')
    }

    const handleGoToAstCatalog = () => {
      uiStore.selectedCatalogTab = CatalogTab.AST_CATALOG
    }

    return (
      <SimpleModal
        show={
          !StoreInstances.searchStore.currentVehicle?.engine &&
          showVehicleRequired
        }
        title="vehicleRequired"
        primaryActionText={
          isMobile ? 'goToASTCatalog' : 'goToAccessoriesSuppliesAndTools'
        }
        onPrimaryAction={handleGoToAstCatalog}
        secondaryActionText={isMobile ? 'selectAVehicle' : 'selectAVehicle'}
        onSecondaryAction={handleVehicleRequired}
        buttonsDirection={isMobile ? 'column' : 'row'}
        primaryButtonToTheLeft={isMobile}
      >
        vehicleRequiredForSearch
      </SimpleModal>
    )
  }
)

VehicleRequiredModal.displayName = 'VehicleRequiredModal'

export default VehicleRequiredModal
